function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.18 22.253c-1.153-1.411-2.757-3.431-2.757-5.483v-6.542C25.423 4.585 21.223 0 15.836 0 10.417 0 6.25 4.585 6.25 10.228v6.542c0 2.02-1.731 3.911-2.854 5.418-.962 1.315-1.763 2.373-1.218 3.431.449.93 1.603 1.026 2.565 1.026h5.74A5.364 5.364 0 0 0 15.836 32a5.364 5.364 0 0 0 5.355-5.355h5.868c.609 0 2.052 0 2.533-1.026.513-1.058-.289-2.02-1.411-3.366zm-12.344 7.663c-1.795 0-3.238-1.475-3.238-3.27h6.477c0 1.795-1.443 3.27-3.239 3.27zm11.223-5.387H4.742c-.128 0-.256 0-.385-.032.225-.32.513-.705.77-1.058 1.218-1.635 3.27-3.944 3.27-6.67v-6.54c0-4.457 3.207-8.08 7.44-8.08 4.232 0 7.47 3.623 7.47 8.08v6.54c0 2.822 1.86 5.163 3.239 6.83.224.289.513.641.737.93h-.224z",
  id: "bell"
});

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "2.285714285714286rem",
    height: "2.285714285714286rem",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.59214fe2.svg";
export { ForwardRef as ReactComponent };